











































































































import Vue from "vue";
import Component from "vue-class-component";
import {useRentalStore} from "@/store/rental";
import type {RentalDevice} from "@/api/models/rental";
import SmbButton from "@/components/ui/SmbButton/SmbButton.vue";

@Component({
  components: {
    SmbButton,
  },
  metaInfo: {
    title: "Leihgeräte verwalten",
  },
})
export default class RentalDevicesList extends Vue {
  public isLoading = true;
  public deletingId: number | null = null;

  public get rentalDevices(): RentalDevice[] {
    return useRentalStore().rentalDevices;
  }

  public async mounted(): Promise<void> {
    await this.loadDevices();
  }

  public async loadDevices(): Promise<void> {
    this.isLoading = true;
    try {
      const rentalStore = useRentalStore();
      await rentalStore.fetchRentalDevices(true);
    } catch (e) {
      console.error("Error loading rental devices:", e);
    } finally {
      this.isLoading = false;
    }
  }

  public getImageUrl(imageId: number): string {
    const rentalStore = useRentalStore();
    return rentalStore.getImageUrl(imageId);
  }

  public isVideo(contentType: string): boolean {
    return contentType === "video/mp4";
  }

  public formatPrice(price: number): string {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(price);
  }

  public async confirmDelete(device: RentalDevice): Promise<void> {
    if (!confirm(`Möchten Sie das Leihgerät "${device.name}" wirklich löschen?`)) {
      return;
    }

    this.deletingId = device.id;
    try {
      const rentalStore = useRentalStore();
      const result = await rentalStore.deleteRentalDevice(device.id);
      if (!result.success) {
        alert(result.message || "Fehler beim Löschen.");
      }
    } catch (e) {
      console.error("Error deleting device:", e);
      alert("Fehler beim Löschen des Leihgeräts.");
    } finally {
      this.deletingId = null;
    }
  }
}
